import { ComboBoxOption } from "../../../models/Input";
import { MathComparisonSymbol, MATH_COMPARISON_SYMBOLS } from "../../../models/Math";
import ComboBox from "../../Control/ComboBox/ComboBox";
import NumberInput from "../../Control/InputBox/NumberInput";
import { ColumnLabel } from "../../Layout/ColumnLabel";

export type CollectedSelectorProps = {
    value: number | null,
    update: (value: number | null) => void,
    operator: ComboBoxOption<MathComparisonSymbol>,
    updateOperator: (value: ComboBoxOption<MathComparisonSymbol>) => void
}

export function CollectedSelector(props: CollectedSelectorProps) {
    return (
        <ColumnLabel
            label="Collected"
            classNames={{ column2: "flex flex-row gap-2" }}
        >
            <ComboBox
                selections={props.operator}
                isMulti={false}
                isSearchable={false}
                options={MATH_COMPARISON_SYMBOLS}
                defaultOption={MATH_COMPARISON_SYMBOLS[0]}
                onChange={(newSelections) => props.updateOperator(newSelections || MATH_COMPARISON_SYMBOLS[0])}
                styles={{
                    container: () => ({
                        minWidth: "75px"
                    })
                }} />

            <NumberInput
                className="flex-1"
                value={props.value}
                onChange={(value) => props.update(value)} />
        </ColumnLabel>
    );
}